import React, { 
  useCallback, useEffect, useMemo, useRef, 
} from 'react';

import { line } from 'd3-shape';
import { select } from 'd3-selection';

import COLORS from '../../../../constants/colors.constants';

import { getCurveFunctionFromType } from '../d3-helpers';

const Line = ({
  id = 'line',
  xScale, 
  yScale, 
  data,
  curve,
  color = COLORS.brand
}) => {
  const lineRef = useRef();
  const lineGenerator = useMemo(() => line()
    .x(d => xScale(d.x))
    .y(d => yScale(d.y))
    .curve(getCurveFunctionFromType(curve)),
  [curve, xScale, yScale]);

  const updateChart = useCallback(() => {
    const lineElem = select(`#${id}`);

    lineElem
      .datum(data)
      .attr('d', lineGenerator)
      .exit()
      .remove();
  }, [id, data, lineGenerator]);

  useEffect(() => {
    updateChart();
  }, [color, data, id, lineGenerator, updateChart, xScale, yScale])

  return <path
    className="line-group"
    ref={lineRef}
    id={id}
    stroke={color}
    strokeWidth={2}
    fill="none"
  />;
}

export default Line;
